import { QIcon, QDrawer, QBtn, QPageContainer, QPage, QLayout, QHeader, QFooter, QPagination, QLinearProgress, QBadge, QToolbar, QSpace, QMenu, QList, QItemSection, QItemLabel, QItem, QTooltip, QChip, debounce, QExpansionItem } from "quasar";
import { defineComponent, createElementBlock, openBlock, Fragment, createCommentVNode, createVNode, normalizeClass, ref, provide, computed, watch, createBlock, withCtx, renderSlot, createElementVNode, normalizeStyle, toDisplayString, mergeProps, createSlots, useSlots, onMounted, resolveDynamicComponent, createTextVNode, createStaticVNode, resolveComponent, renderList } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, RouterView } from "vue-router";
import { defineStore } from "pinia";
import { useGlobalStore, useUserStore, LanguageSelector, DEFAULT_SIDEBAR_NAV_WIDTH } from "@editor/ui-utils";
import { ListPagination } from "@editor/ui-utils";
const HEADER_HEIGHT_HINT = 98;
const BLOCK_DRAWER_MINI_WIDTH = 125;
const BLOCK_DRAWER_WIDTH = 300;
const BLOCK_DRAWER_CONFIG = {
  width: BLOCK_DRAWER_WIDTH,
  miniWidth: BLOCK_DRAWER_MINI_WIDTH,
  isDrawerOpenInitValue: true
};
const _sfc_main$a = defineComponent({
  components: { QIcon },
  props: {
    value: {
      type: String,
      required: true,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "24"
      // default icon size
    }
  },
  computed: {
    iconClass() {
      if (this.value === "check-circle")
        return "green--text text--darken-1";
      if (this.value === "download")
        return "green--text text--darken-1";
      if (this.value === "clock")
        return "blue--text text--darken-3";
      if (["minus-circle", "x-circle"].includes(this.value))
        return "red--text";
      if (this.value === "alert-circle")
        return "orange--text";
      return "grey--text text--darken-1";
    }
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      createCommentVNode(" eslint-disable-next-line "),
      createVNode(QIcon, {
        class: normalizeClass(["d-flex align-self-center", _ctx.iconClass]),
        size: _ctx.size,
        name: _ctx.value
      }, null, 8, ["class", "size", "name"])
    ],
    2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}
const statusIcon = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/components/status-icon.vue"]]);
const LAYOUT_DEFAULTS = {
  isLeftDrawerOpen: true,
  isRightDrawerOpen: true
};
const usePersistedLayout = defineStore("layout", {
  state() {
    return {
      layouts: {}
    };
  },
  actions: {
    getLayout(id) {
      if (!id)
        return;
      return this.layouts[id];
    },
    setLayout(newLayout, id) {
      if (!id)
        return;
      const prevLayout = this.layouts[id] || {};
      this.layouts[id] = {
        ...LAYOUT_DEFAULTS,
        ...prevLayout,
        ...newLayout
      };
    },
    resetLayout(id) {
      if (!id)
        return;
      this.layouts[id] = LAYOUT_DEFAULTS;
    },
    removeLayout(id) {
      delete this.layouts[id];
    },
    removeAllLayouts() {
      this.layouts = {};
    }
  },
  persist: true
});
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "layout-drawer",
  props: {
    side: { type: null, required: true, default: "left" },
    behaviour: { type: null, required: false, default: "desktop" },
    width: { type: Number, required: false, default: void 0 },
    miniWidth: { type: Number, required: false, default: void 0 },
    isDrawerOpenInitValue: { type: Boolean, required: false, default: true },
    layoutId: { type: String, required: false, default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const layoutsStore = usePersistedLayout();
    const isDrawerOpen = ref(props.isDrawerOpenInitValue);
    provide("isDrawerOpen", isDrawerOpen);
    const collapseIconName = computed(() => {
      const iconMap = {
        left: isDrawerOpen.value ? "chevrons-left" : "chevrons-right",
        right: isDrawerOpen.value ? "chevrons-right" : "chevrons-left"
      };
      return iconMap[props.side];
    });
    watch(isDrawerOpen, (isDrawerOpen2) => {
      switch (props.side) {
        case "left":
          layoutsStore.setLayout({ isLeftDrawerOpen: isDrawerOpen2 }, props.layoutId);
          break;
        case "right":
          layoutsStore.setLayout({ isRightDrawerOpen: isDrawerOpen2 }, props.layoutId);
          break;
      }
    });
    watch(
      () => props.layoutId,
      (id) => {
        if (!id)
          return;
        const layout = layoutsStore.getLayout(id);
        const drawerOpenMap = {
          left: layout == null ? void 0 : layout.isLeftDrawerOpen,
          right: layout == null ? void 0 : layout.isRightDrawerOpen
        };
        isDrawerOpen.value = drawerOpenMap[props.side] ?? props.isDrawerOpenInitValue;
      },
      { immediate: true }
    );
    const __returned__ = { props, layoutsStore, isDrawerOpen, collapseIconName, get QBtn() {
      return QBtn;
    }, get QDrawer() {
      return QDrawer;
    }, get QIcon() {
      return QIcon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.$slots["drawer-content"] ? (openBlock(), createBlock($setup["QDrawer"], {
    key: 0,
    "model-value": true,
    "show-if-above": "",
    side: $props.side,
    mini: !$setup.isDrawerOpen,
    width: $props.width,
    "mini-width": $props.miniWidth,
    behavior: $props.behaviour,
    bordered: ""
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "drawer-content", {}, void 0, true),
      createElementVNode(
        "div",
        {
          class: normalizeClass(["row drawer-footer", $props.side === "left" ? "justify-end" : "justify-start"])
        },
        [
          createVNode($setup["QBtn"], {
            color: "primary",
            flat: "",
            onClick: _cache[0] || (_cache[0] = ($event) => $setup.isDrawerOpen = !$setup.isDrawerOpen)
          }, {
            default: withCtx(() => [
              createVNode($setup["QIcon"], {
                size: "24px",
                name: $setup.collapseIconName
              }, null, 8, ["name"])
            ]),
            _: 1
            /* STABLE */
          })
        ],
        2
        /* CLASS */
      )
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["side", "mini", "width", "mini-width", "behavior"])) : createCommentVNode("v-if", true);
}
const LayoutDrawer = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-f9532c89"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/components/layout-drawer.vue"]]);
const globalStore = useGlobalStore();
const qLayoutStyles = computed(() => ({
  width: `calc(100vw - ${globalStore.sidebarNavigationWidth}px)`,
  height: `calc(100vh - ${globalStore.headerNavigationHeight}px)`,
  top: `${globalStore.headerNavigationHeight}px`,
  left: `${globalStore.sidebarNavigationWidth}px`,
  transition: "left 0.2s"
  // same transition duration as main sidebar menu
}));
const qLayoutDialogStyles = computed(() => ({
  width: "calc(100vw - 48px)",
  // 48px = 2x 24px padding of fullscreen modal
  height: "calc(100vh - 48px)"
}));
const qHeaderLayoutStyles = computed(() => ({
  width: `calc(100vw - ${globalStore.sidebarNavigationWidth}px)`,
  left: `${globalStore.sidebarNavigationWidth}px`,
  transition: "left 0.2s"
  // same transition duration as main sidebar menu
}));
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "edit-view.layout",
  props: {
    backRoute: { type: String, required: false, default: void 0 },
    backButtonLabel: { type: String, required: false, default: void 0 },
    backButtonOffset: { type: Boolean, required: false, default: true },
    id: { type: String, required: false, default: void 0 },
    hasLayoutContentPadding: { type: Boolean, required: false, default: true },
    dialog: { type: Boolean, required: false, default: false },
    leftDrawerProps: { type: Object, required: false, default: void 0 },
    rightDrawerProps: { type: Object, required: false, default: void 0 }
  },
  emits: ["back:clicked", "back:modal", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const onClickBack = () => {
      if (props.backRoute && props.dialog) {
        emit("back:modal");
      }
      if (window.history.length > 1 && !props.backRoute) {
        router.go(-1);
        emit("back:clicked");
      } else {
        router.push(props.backRoute || "/");
        emit("back:clicked");
      }
    };
    const __returned__ = { t, router, props, emit, onClickBack, get QBtn() {
      return QBtn;
    }, get QFooter() {
      return QFooter;
    }, get QHeader() {
      return QHeader;
    }, get QIcon() {
      return QIcon;
    }, get QLayout() {
      return QLayout;
    }, get QPage() {
      return QPage;
    }, get QPageContainer() {
      return QPageContainer;
    }, LayoutDrawer, get HEADER_HEIGHT_HINT() {
      return HEADER_HEIGHT_HINT;
    }, get qLayoutDialogStyles() {
      return qLayoutDialogStyles;
    }, get qLayoutStyles() {
      return qLayoutStyles;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$4 = { class: "row" };
const _hoisted_2$3 = {
  key: 1,
  class: "text-right"
};
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QLayout"], {
    view: "hhh LpR fFf",
    class: "bg-white",
    container: "",
    style: normalizeStyle($props.dialog ? $setup.qLayoutDialogStyles : $setup.qLayoutStyles)
  }, {
    default: withCtx(() => [
      createVNode($setup["QHeader"], {
        class: "layout-header q-layout-padding q-pt-sm q-pb-none row",
        "height-hint": $setup.HEADER_HEIGHT_HINT
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "layout-header", {}, void 0, true),
          createElementVNode("div", _hoisted_1$4, [
            renderSlot(_ctx.$slots, "layout-header-right", {}, void 0, true),
            $props.backRoute ? (openBlock(), createBlock($setup["QBtn"], {
              key: 0,
              "data-qa-back-button": "",
              link: "",
              outline: "",
              class: normalizeClass(["custom-back-button q-mt-xs q-mb-sm", { "q-ml-auto": $props.backButtonOffset }]),
              color: "secondary",
              onClick: $setup.onClickBack
            }, {
              default: withCtx(() => [
                createVNode($setup["QIcon"], {
                  color: "primary",
                  name: "chevron_left"
                }),
                createElementVNode(
                  "span",
                  null,
                  toDisplayString($props.backButtonLabel || $setup.t("common.back")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])) : createCommentVNode("v-if", true),
            $props.dialog ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
              createVNode($setup["QBtn"], {
                "data-qa-close-modal-button": "",
                icon: "close",
                flat: "",
                round: "",
                onClick: _cache[0] || (_cache[0] = ($event) => $setup.emit("close"))
              })
            ])) : createCommentVNode("v-if", true)
          ])
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["height-hint"]),
      createVNode($setup["LayoutDrawer"], mergeProps({ side: "left" }, $props.leftDrawerProps, { "layout-id": $props.id }), createSlots({
        _: 2
        /* DYNAMIC */
      }, [
        _ctx.$slots["layout-left-drawer"] ? {
          name: "drawer-content",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "layout-left-drawer", {}, void 0, true)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["layout-id"]),
      createVNode($setup["LayoutDrawer"], mergeProps({ side: "right" }, $props.rightDrawerProps, { "layout-id": $props.id }), createSlots({
        _: 2
        /* DYNAMIC */
      }, [
        _ctx.$slots["layout-right-drawer"] ? {
          name: "drawer-content",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "layout-right-drawer", {}, void 0, true)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["layout-id"]),
      createVNode($setup["QPageContainer"], null, {
        default: withCtx(() => [
          createVNode($setup["QPage"], {
            class: "layout-content",
            padding: $props.hasLayoutContentPadding
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "layout-content", {}, void 0, true)
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["padding"])
        ]),
        _: 3
        /* FORWARDED */
      }),
      _ctx.$slots["layout-footer"] ? (openBlock(), createBlock($setup["QFooter"], {
        key: 0,
        class: "layout-footer q-layout-padding row"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "layout-footer", {}, void 0, true)
        ]),
        _: 3
        /* FORWARDED */
      })) : createCommentVNode("v-if", true)
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["style"]);
}
const editView_layout = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-9c3c75f9"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/layouts/edit-view.layout.vue"]]);
const MAX_LISTED_PAGES = 6;
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "list-pagination",
  props: {
    pagination: { type: Object, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const paginationModel = computed({
      get() {
        var _a;
        return ((_a = props.pagination) == null ? void 0 : _a.currentPage) ?? 1;
      },
      set(value) {
        var _a;
        (_a = props.pagination) == null ? void 0 : _a.goToPage(value);
      }
    });
    const paginationMax = computed(() => {
      var _a, _b;
      const currentPage = ((_a = props.pagination) == null ? void 0 : _a.currentPage) ?? 1;
      const nextPageLink = (_b = props.pagination) == null ? void 0 : _b.nextPageLink;
      const pageRequestQueryParam = "page";
      const nextPageNumber = nextPageLink && Number(new URL(nextPageLink).searchParams.get(pageRequestQueryParam)) > currentPage ? 1 : 0;
      return currentPage + nextPageNumber;
    });
    const paginationMaxPages = computed(() => {
      return paginationMax.value >= MAX_LISTED_PAGES ? MAX_LISTED_PAGES : paginationMax.value;
    });
    const __returned__ = { props, MAX_LISTED_PAGES, paginationModel, paginationMax, paginationMaxPages, get QPagination() {
      return QPagination;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  return openBlock(), createBlock($setup["QPagination"], {
    modelValue: $setup.paginationModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.paginationModel = $event),
    max: $setup.paginationMax,
    "max-pages": $setup.paginationMaxPages,
    disable: (_a = $props.pagination) == null ? void 0 : _a.loading,
    "direction-links": "",
    "boundary-links": "",
    "icon-first": "skip_previous",
    "icon-last": "skip_next",
    "icon-prev": "fast_rewind",
    "icon-next": "fast_forward",
    "active-color": "primary"
  }, null, 8, ["modelValue", "max", "max-pages", "disable"]);
}
const ListPagination2 = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/components/list-pagination.vue"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "list-view.layout",
  props: {
    selectedFilterCount: { type: Number, required: false, default: 0 },
    multi: { type: Boolean, required: false },
    multiLabel: { type: String, required: false, default: "" },
    newButtonLabel: { type: String, required: false, default: "" },
    newButtonClass: { type: String, required: false, default: "col-auto q-pa-sm" },
    newRoute: { type: String, required: false, default: "" },
    showNewButton: { type: Boolean, required: false, default: true },
    pagination: { type: Object, required: false, default: void 0 },
    dialog: { type: Boolean, required: false, default: false },
    hideClose: { type: Boolean, required: false, default: false },
    hideFooter: { type: Boolean, required: false, default: false },
    shouldRemoveScrollElement: { type: Boolean, required: false, default: true }
  },
  emits: ["clear-filters", "close", "new-btn:clicked", "save-multi-selection", "back:modal"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const areExtraFiltersVisible = ref(false);
    const slots = useSlots();
    const isFooterVisible = computed(() => {
      var _a, _b;
      if (props.hideFooter)
        return false;
      if (((_a = props.pagination) == null ? void 0 : _a.nextPageLink) || ((_b = props.pagination) == null ? void 0 : _b.previousPageLink))
        return true;
      if (props.multi)
        return true;
      return !!slots["footer"];
    });
    const removeScrollElement = () => {
      if (document.getElementsByClassName("q-table__middle")[0]) {
        const testElements = document.getElementsByClassName("q-table__middle")[0];
        return testElements.classList.remove("scroll");
      }
    };
    onMounted(() => props.shouldRemoveScrollElement && removeScrollElement());
    const __returned__ = { props, emit, t, areExtraFiltersVisible, slots, isFooterVisible, removeScrollElement, get QBadge() {
      return QBadge;
    }, get QBtn() {
      return QBtn;
    }, get QDrawer() {
      return QDrawer;
    }, get QFooter() {
      return QFooter;
    }, get QHeader() {
      return QHeader;
    }, get QIcon() {
      return QIcon;
    }, get QLayout() {
      return QLayout;
    }, get QLinearProgress() {
      return QLinearProgress;
    }, get QPage() {
      return QPage;
    }, get QPageContainer() {
      return QPageContainer;
    }, ListPagination: ListPagination2, get qLayoutDialogStyles() {
      return qLayoutDialogStyles;
    }, get qLayoutStyles() {
      return qLayoutStyles;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$3 = { class: "row" };
const _hoisted_2$2 = {
  key: 0,
  class: "col-grow q-py-sm"
};
const _hoisted_3$1 = { class: "row" };
const _hoisted_4$1 = {
  key: 0,
  class: "col-md-12"
};
const _hoisted_5$1 = {
  key: 2,
  class: "col-grow flex justify-end self-center q-mr-sm"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = {
  key: 1,
  class: "q-pt-sm"
};
const _hoisted_9 = { style: { "position": "relative" } };
const _hoisted_10 = { class: "row overflow-y-auto w-full mx-0" };
const _hoisted_11 = { style: { "width": "100%" } };
const _hoisted_12 = { class: "row justify-end q-pa-sm" };
const _hoisted_13 = { class: "q-pa-md" };
const _hoisted_14 = {
  key: 0,
  class: "list-footer row"
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QLayout"], {
    view: "hHh lpR fFf",
    class: "bg-white",
    container: "",
    style: normalizeStyle($props.dialog ? $setup.qLayoutDialogStyles : $setup.qLayoutStyles)
  }, {
    default: withCtx(() => [
      (openBlock(), createBlock(resolveDynamicComponent($props.dialog || $setup.areExtraFiltersVisible ? $setup.QHeader : "header"), {
        bordered: "",
        class: "text-black bg-white q-layout-padding q-py-sm"
      }, {
        default: withCtx(() => [
          $props.dialog ? (openBlock(), createElementBlock(
            "div",
            {
              key: 0,
              class: normalizeClass(["text-right", { hidden: $props.hideClose }])
            },
            [
              createVNode($setup["QBtn"], {
                "data-qa-close-modal-button": "",
                icon: "close",
                flat: "",
                round: "",
                onClick: _cache[0] || (_cache[0] = ($event) => $setup.emit("close"))
              })
            ],
            2
            /* CLASS */
          )) : createCommentVNode("v-if", true),
          renderSlot(_ctx.$slots, "all-filters", { areExtraFiltersVisible: $setup.areExtraFiltersVisible }, () => [
            createElementVNode("div", _hoisted_1$3, [
              !!_ctx.$slots["main-filters"] ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
                renderSlot(_ctx.$slots, "main-filters", {}, void 0, true)
              ])) : createCommentVNode("v-if", true),
              !!_ctx.$slots["new-button"] || $props.showNewButton ? (openBlock(), createElementBlock(
                "div",
                {
                  key: 1,
                  class: normalizeClass($props.newButtonClass)
                },
                [
                  renderSlot(_ctx.$slots, "new-button", {}, () => [
                    $props.showNewButton ? (openBlock(), createBlock($setup["QBtn"], {
                      key: 0,
                      to: $props.newRoute,
                      block: "",
                      "data-qa-new-button": "",
                      class: "layout-btn",
                      color: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event) => $setup.emit("new-btn:clicked"))
                    }, {
                      default: withCtx(() => [
                        createVNode($setup["QIcon"], {
                          class: "mr-2",
                          name: "add"
                        }),
                        createTextVNode(
                          " " + toDisplayString($props.newButtonLabel),
                          1
                          /* TEXT */
                        )
                      ]),
                      _: 1
                      /* STABLE */
                    }, 8, ["to"])) : createCommentVNode("v-if", true)
                  ], true)
                ],
                2
                /* CLASS */
              )) : createCommentVNode("v-if", true)
            ]),
            createElementVNode("div", _hoisted_3$1, [
              !!_ctx.$slots["secondary-filters"] ? (openBlock(), createElementBlock("div", _hoisted_4$1)) : createCommentVNode("v-if", true),
              !!_ctx.$slots["secondary-filters"] ? renderSlot(_ctx.$slots, "secondary-filters", { key: 1 }, void 0, true) : createCommentVNode("v-if", true),
              !!_ctx.$slots["extra-filters"] ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
                createVNode($setup["QBtn"], {
                  "data-qa-filter-button": "",
                  class: normalizeClass([{ "layout-btn-active": $setup.areExtraFiltersVisible }, "layout-btn px-1"]),
                  "min-width": "55",
                  outlined: "",
                  onClick: _cache[2] || (_cache[2] = ($event) => $setup.areExtraFiltersVisible = !$setup.areExtraFiltersVisible)
                }, {
                  default: withCtx(() => [
                    createVNode($setup["QIcon"], {
                      color: "primary",
                      name: "filter"
                    }),
                    $props.selectedFilterCount > 0 ? (openBlock(), createBlock($setup["QBadge"], {
                      key: 0,
                      "data-qa-filter-count": "",
                      bordered: "",
                      bottom: "",
                      color: "black",
                      "offset-x": "15",
                      "offset-y": "20",
                      overlap: ""
                    }, {
                      default: withCtx(() => [
                        createTextVNode(
                          toDisplayString($props.selectedFilterCount),
                          1
                          /* TEXT */
                        )
                      ]),
                      _: 1
                      /* STABLE */
                    })) : createCommentVNode("v-if", true)
                  ]),
                  _: 1
                  /* STABLE */
                }, 8, ["class"])
              ])) : createCommentVNode("v-if", true)
            ]),
            createElementVNode("div", _hoisted_6, [
              !!_ctx.$slots["third-filters"] ? (openBlock(), createElementBlock("div", _hoisted_7)) : createCommentVNode("v-if", true),
              !!_ctx.$slots["third-filters"] ? (openBlock(), createElementBlock("div", _hoisted_8, [
                renderSlot(_ctx.$slots, "third-filters", {}, void 0, true)
              ])) : createCommentVNode("v-if", true)
            ])
          ], true)
        ]),
        _: 3
        /* FORWARDED */
      })),
      createVNode($setup["QPageContainer"], null, {
        default: withCtx(() => [
          createVNode($setup["QPage"], { padding: "" }, {
            default: withCtx(() => {
              var _a;
              return [
                ((_a = $props.pagination) == null ? void 0 : _a.loading) ? (openBlock(), createBlock($setup["QLinearProgress"], {
                  key: 0,
                  indeterminate: ""
                })) : createCommentVNode("v-if", true),
                createElementVNode("div", _hoisted_9, [
                  createElementVNode("div", _hoisted_10, [
                    createElementVNode("div", _hoisted_11, [
                      renderSlot(_ctx.$slots, "table", {}, void 0, true)
                    ])
                  ]),
                  createCommentVNode(" overlay closes the drawer on every input selection. As it is not the desired behaviour and there is no prop to fix it, I replaced it with mini-to-overlay. "),
                  createVNode($setup["QDrawer"], {
                    modelValue: $setup.areExtraFiltersVisible,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $setup.areExtraFiltersVisible = $event),
                    side: "right",
                    bordered: "",
                    behavior: "desktop",
                    "mini-to-overlay": ""
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_12, [
                        createElementVNode(
                          "a",
                          {
                            "data-qa-remove-filters-button": "",
                            class: "clear-filters-btn",
                            onClick: _cache[3] || (_cache[3] = ($event) => $setup.emit("clear-filters"))
                          },
                          toDisplayString($setup.t("listView.filterDelete")),
                          1
                          /* TEXT */
                        )
                      ]),
                      createElementVNode("div", _hoisted_13, [
                        renderSlot(_ctx.$slots, "extra-filters", {}, void 0, true)
                      ])
                    ]),
                    _: 3
                    /* FORWARDED */
                  }, 8, ["modelValue"])
                ])
              ];
            }),
            _: 3
            /* FORWARDED */
          })
        ]),
        _: 3
        /* FORWARDED */
      }),
      $setup.isFooterVisible ? (openBlock(), createBlock($setup["QFooter"], {
        key: 0,
        bordered: "",
        class: "bg-white flex justify-center q-pa-md"
      }, {
        default: withCtx(() => [
          createVNode($setup["ListPagination"], { pagination: $props.pagination }, null, 8, ["pagination"]),
          !!_ctx.$slots["footer"] || $props.multi ? (openBlock(), createElementBlock("div", _hoisted_14, [
            renderSlot(_ctx.$slots, "footer", {}, () => [
              createVNode($setup["QBtn"], {
                class: "mr-4",
                color: "primary",
                onClick: _cache[5] || (_cache[5] = ($event) => $setup.emit("save-multi-selection"))
              }, {
                default: withCtx(() => [
                  createVNode($setup["QIcon"], {
                    class: "mr-2",
                    name: "send"
                  }),
                  createTextVNode(
                    " " + toDisplayString($props.multiLabel),
                    1
                    /* TEXT */
                  )
                ]),
                _: 1
                /* STABLE */
              }),
              createVNode($setup["QBtn"], {
                color: "secondary",
                outline: "",
                onClick: _cache[6] || (_cache[6] = ($event) => $setup.emit("close"))
              }, {
                default: withCtx(() => [
                  createTextVNode(
                    toDisplayString($setup.t("common.cancel")),
                    1
                    /* TEXT */
                  )
                ]),
                _: 1
                /* STABLE */
              })
            ], true)
          ])) : createCommentVNode("v-if", true)
        ]),
        _: 3
        /* FORWARDED */
      })) : createCommentVNode("v-if", true)
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["style"]);
}
const listView_layout = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-28a0154a"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/layouts/list-view.layout.vue"]]);
const burdaLogo = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20800%20118.2'%20style='enable-background:new%200%200%20800%20118.2;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%2395C11F;}%20.st1{fill:%23F39200;}%20.st2{fill:%231D1D1B;}%20%3c/style%3e%3cpath%20class='st0'%20d='M0,0h344.1v118.2H0V0z'/%3e%3cpath%20class='st1'%20d='M344.1,0H800v118.2H344.1V0z'/%3e%3cpath%20class='st2'%20d='M41.7,20.2h39.2c7.5,0,12.9,1.9,17,4.8c4.7,3.6,7.3,9,7.2,14.9c0,7.2-3.1,11.8-9.5,14.5v0.3%20c7.9,2.5,13.4,10,13.1,18.2c0,8.1-3.3,14.3-8.7,18.2c-4.5,3.1-10.6,4.8-18.4,4.8h-40C41.7,96.1,41.7,20.2,41.7,20.2L41.7,20.2z%20M77.3,49.8c4.2,0,7.2-2,7.2-6.1s-3-6.2-7.2-6.2H63.6v12.3L77.3,49.8L77.3,49.8z%20M79.3,78.9c4.8,0,8.1-2.8,8.1-7.5%20c0-4.8-3.6-7.3-8.1-7.3H63.6v14.8C63.6,78.9,79.3,78.9,79.3,78.9z%20M149.5,96.1v-7h-0.3c-3.7,5.6-10.1,8.9-16.8,8.6%20c-12.9,0-19.3-8.6-19.3-20.8V42h20.1v30.2c0,5.6,2.5,8.6,7.2,8.6c5.1,0,8.2-3.7,8.2-9.5V42.1h20.1v54L149.5,96.1L149.5,96.1z%20M194.8,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6V96h-20.1V42h19.1%20L194.8,50.2L194.8,50.2z%20M217,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2%20c-3.1,5.8-9.3,9.3-15.9,9.3C227.5,97.8,217,87.7,217,69.1z%20M257.2,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8%20c0,8.2,3.7,14.2,9.8,14.2S257.2,76.5,257.2,68.7z%20M316.9,89.9h-0.2c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2%20c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4%20c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3v11.4c-2.8,1.1-5.8,1.6-8.9,1.6%20C322.4,97.1,318.2,94.9,316.9,89.9L316.9,89.9z%20M316.1,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5c-5.9,1.2-7.6,3-7.6,6.2%20c0,3.6,3,5.1,6.2,5.1C311.6,85.5,316.1,83.1,316.1,76.5L316.1,76.5z%20M344.1,20.2h58.5v18.7h-36.3v12.4h30v17.1h-30v27.5h-22.1%20C344.1,96.1,344.1,20.2,344.1,20.2z%20M401.4,69.2c0-16.5,11.7-28.8,29.7-28.8s29.6,12.3,29.6,28.8s-11.5,28.6-29.6,28.6%20S401.4,85.5,401.4,69.2z%20M440.3,69.2c0-9.2-3.1-15.2-9.3-15.2c-6.2,0-9.2,6.2-9.2,15.2s3,15.2,9.2,15.2%20C437.2,84.5,440.3,78.4,440.3,69.2z%20M484.6,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.3%20c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L484.6,50.2L484.6,50.2z%20M507.2,42h20.7l5.3,19.6c1.2,4.2,2.5,10.9,2.5,10.9h0.2%20c0,0,1.4-6.7,2.5-11.2l4.6-19.2h17l4.7,19.1c1.2,4.7,2.5,11.5,2.5,11.5h0.2c0,0,1.6-6.8,2.6-11l5-19.6h20.2l-17.1,54.1h-19.3%20l-5.4-22.6c-1.1-4.2-2.2-10.1-2.2-10.1H551c0,0-1.2,5.9-2.2,10.1L543.4,96h-19L507.2,42L507.2,42z%20M629.5,89.9h-0.2%20c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1%20s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3%20v11.4c-2.8,1.1-5.8,1.6-8.9,1.6C635.1,97.1,630.9,94.9,629.5,89.9L629.5,89.9z%20M628.7,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5%20c-5.9,1.2-7.6,3-7.6,6.2c0,3.6,3,5.1,6.2,5.1C624.2,85.5,628.7,83.1,628.7,76.5L628.7,76.5z%20M674.8,50.2h0.3%20c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L674.8,50.2L674.8,50.2z%20M697,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2c-3.1,5.8-9.3,9.3-15.9,9.3%20C707.4,97.8,697,87.7,697,69.1L697,69.1z%20M737.1,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8s3.7,14.2,9.8,14.2%20S737.1,76.5,737.1,68.7z'/%3e%3c/svg%3e";
const bfLogo = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8PDQ0PDRAQEA8PEA8PEBAPDRANEg0QFRIWFxYSFRUZHSggGBolHRUVIjIhJSorLi8uFx8zOjMtNzQvLi4BCgoKDg0OGRAQGysmHx0tKy0tLi0yLS0tKy0tKystLS0tLS0tKy0tKy0tLS0tLS0tLS0rLS0tLS0tLS0tLS0tLf/AABEIAOEA4QMBEQACEQEDEQH/xAAbAAEAAwADAQAAAAAAAAAAAAAAAQYHAwQFAv/EAEUQAAEDAQEJDAcFCAMAAAAAAAABAgMEEQUHEiExVJGT0QYTFTRBUVJzdJKysxYXM2FxgaEiMpTS8BRDU2JygsHDJLHh/8QAGgEBAAIDAQAAAAAAAAAAAAAAAAEGAgMEBf/EACsRAQABAwEHBAICAwAAAAAAAAABAgMRUQQFEhQhMTITM0FhFVIicSNCgf/aAAwDAQACEQMRAD8A9worQAAAAAAAAAAAAAAACKvF0bL7sIONbqe0ASAAAAAAAAAAAAAAk7VIAAAAAAAAAAAAAAABFXi6Nl92EHGt1PaAJAAAAAAAAAAAAAASdqkAAAAAAAAAAAAAAAAirxdGy+7CDjW6ntAEgAAAAAAAAAAAAAJO1SAAAAAAAAAAAAAAAARV4ujZfdhBxrdT2gCQAAAAAAAAAAAAAEnapAAAAAAAAAAAAAAAAIq8XRsvuwg41up7QBIAAAAAAAAAAAAACTtUgAAAAAAAAAAAAAAAEVeLo2X3YQca3U9oAkAAAAAAAAAAAAABJ2qQAB/UIgJxOicAxOhgGJ0MAxOhgGJ0MAxOhgGJAgBmEAxV8pACmFWcYdGze7CDRwVaLdGIpgI4KtDi+gcFWhxfQOCrQ4voHBVocX0Dgq0OL6BwVaHF9A4KtDi+gcFWhxfQOCrQ4voExiOsMsRqGOOmUAACTtUgEitbv6uWGkjdDI+Nyztaro3qxVRY5MVqcmJD192UUVzOYyyphQeHazO6nXybT2+Wt6NmDh2szup18m0jlrehg4drM7qdfJtHLW9DBw7WZ3U6+TaOWt6GDh2szup18m0ctb0MHDtZnVTr5No5a3oYOHa3O6nXv2jlrXzScMOSPdJXt+7VTf3K1/iRSJ2SxP8AqcMPWod3dUyxJmxzJ8N6dpS1Poc1zdlqqP49GM0LhcPdNTVn2WKscv8ACksRy/0rkcn6sQ8i/sFy11nrDDhe0efM/KHTuw9W0tS5qq1zYZVRyKqK1Uatiopv2WmJuxlnRVMdWTJd6tzqo18m0tPK2p+IddO03Yjunh6tzqp18m0nlLWkJ5q7qcPVudVOvk2kcpa0g5q7qcPVudVOvk2k8pa0g5q7qcPVudVOvk2jlLWkHNXdTh6tzqp18m0jlLWkHNXdTh6tzqp18m0nlLWkHNXdTh6tzqp18m0jlLWkHNXdTh6tzqp18m0cpa0g5q7qcPVudVOvk2k8pa0g5q7qtl766M801Sk0ssiNjYrUkkc/BXCy41PH3taoot9Iehu+5XVOJlditfD2AgAJO1SAmO4qd8riUXaGeXIexubyqZUM3LA2gAAAAAAAACWrYtqWoqY0VFsVFTIqLyKRNMT37DSNxW6RalN4qFtmYlrX8szPf/Mn/pX947HFM+pR2appw967nE6rqZfAp5+ye7BDGC4U9m0JAAAAAAAAABc72ft6rqo/Gp4W+vah6u7PcloBV5e2EABJ2qQEx3FTvlcSi7Qzy5D2NzeVTKhm5YG0AABH2AyAzAAB1AAT3jA5qOqdBLHMz70T2vT3qmVPmmL5mq7TFVHBPYnq126kySUE725H0z3p8FjtKvao4L+Ptqjuxwtcdm0JAAM4AiZ0J6BOfpIM/SMAz9GAZ+jAM/Rhc72ft6rqmeNTw99e1D1t10z6ktAKtL2swEABJ2qQEx3FTvlcSi7Qzy5D2NzeVTKhm5YG0AAWHcVcmCrnmZUNc5rYkemC90ePCRMrVOLb9ouWaImljNWFw9CLn/w3/iZvzHjzvW9DDjPQe5/8OT8TN+YflrxxuCq3BUjmqkKyRO5FWRZUt96O5PgqGy1vWqasVJ42f3UoH0074ZU+0zIqW2OauNHJ7lPctXorpzDZFWXVNoACKoGoXNerrhNVczkb3WuT/BXL8Y2uGqPJl5ZJ+G2e4AA+4I8N7GJiw3NbbzWqif5IqqimMyypo4pwt/q9mzmPUv2nkfm7VNU04ejG7pmIPV7NnMepftMPzlrSU/jKj1ezZzHqX7R+ctfrJ+LqPV7NnEepftH5u1+sn4uo9Xs2cR6l+0fm7X6yfi6j1ezZxHqX7R+ctfrJ+Lqe7uU3NPopJnvlbJvjWsTBY5tli224zg3jvGjabcREOzY9kqsVzlZDxJehj5CAAk7VICY7ip3yuJRdoZ5ch7G5vKplQzcsDaAALfez41UdSnjQ8rek/wCNhU0UrVLUGXRIR/Qze+S9q1kSJZhpCiP+CvXBT/vSWXdcf4erZbjCpnqMwfYDMTGZGrx0yw3H3t2VtG5Hf1YCqv1UrNyvj2rMatX+zKCyx8Ns9wkAOxc/28HWx+NDVe9uf6bLPnDa1yqUKrv/ANWqn4DXPdkAAAAAAAAAJO1SAmO4qd8riUXaGeXIexubyqZUM3LA2gAD2dy920oZZJHRrJhswLEejLPtItuNPcce17P61PDljMZWX1iMzV+vb+U8yN1Y6cTHgPWJHmsmvb+Un8V9nA4Kq+G9UVIKZGrZ9+SbDwf7Ualuk3Wt2U0zmZTwKbVVL5ZHyyuV0j1tc5eXEiaMR61uimijhiGcOIyAfQse424DqqZsr0sp4nIrlVMUrmrajGrypbZavxT4cG37VTbt8Md2My0S7nE6rqZfCpX9lnN2MsI75YwW6ns2hIAc1E5GzQqq2Ikkaqq8iI5LVMLlM1UTENlqcVxlrK7oaLOoe+U6rd1/jmMLBRtVE4PSKizmHvoY/jb+jPmqD0ios5h76Efjb+hzVB6RUWcw99B+Nv6HNUanpFRZzD30H42/jsc1b1dyiroZ2udBI2RGrgqrFwkRbLbDRf2auzMRX8ttu5FynNLsHO2AAABJ2qQEx3FTvlcSi7Qzy5D2NzeVTKhm5YG0AACcwBHQCeoEYAkCB37iyUrZba2OSSPFYjHIjUX+dMrk9yLz5TRfiuaf4d2NTWblVtPNE1aRzHRt+yjWpg73i+6rcWCtnIVfaLNymrNzu1yi7nE6rqZfApjsnuwUsYLhT2bgkAAARFNPeWWZBNNOqOoRw06mZBw06mZB2jomJ1lod7Nf+NU9o/1MK7v6etL2N1ZiiVwK49YAAAJO1SAmO4qd8riUXaGeXIexubyqZUM3LA2gAARxYAcUQA4oAcUSBM9OycAQCew7ly7pS00rZYXYLkstTK17bcbXJyoa7tii9bxUYaYt1GVdy6iaPFbDKj2rljfgLa1fpYvKhXI2edn2iKWqY/kycs8RjEN0gQAAAwAAYAYAfCYaHey4tU9o/wBTCt7870Pa3Z4SuBXXqgAABJ2qQEx3FTvlcSi7Qzy5D2NzeVTKhm5YG0AAWi9/RxTVE7Z445WpEiokjGvRFw0x2Ly41PO3jeqt0RNLCqV74Bos1pvw0Ww8OdvvT8tZwDRZpTfhotg5+/qZQ7c/Qqli0lP8oI2rpRLUMo3heiO5mVU3W7kI4on1FJajY0wpIrVciN5XNVceLlT3fI9PYdum5OKmcVqQexE5bAZATED3dy90VjSrgVVwKimmsTk3xkbnJpRFTQcl+1FVUVaImOrwjqpnMdUhIAEEzgfe8v6D+47Ya/VoxnLb6Neid4f0H9x2wn1aNYR6VWhvL+g/uO2D1aNYPSq0N5f0H9x2werRrB6VWhvD+g/uOHq0awenVHw0G9rG5tNUYSKls9uNFT92xOUrm+5irhx8PY3bExTMStxX3qAAABJ2qQEx3FTvlcSi7Qzy5D2NzeVTKhm5YG0AAW+9nxqo6lPGh5W9fbYVNFK38NQEg+Rw1qpvMuF93e5LbcaWYKnRs3F6kYIYezInwTLzFwhvfRIAfcMitcjk5LdCpYv0FUZHwT8AQAHPc/28HWxeNDXe8JbLPnDbFyqUa5drmqYiVoooonHQMJvXNT06NAj1rmqfTo0B61zU9OjQJi9XqjgpiewYVXKp7tnBTHYMAAAAJO1SAmO4qd8riUXaGeXIexubyqZUM3LA2gACz7ga+GCondPKyJqxI1Fe5Goq4aYjz942blyiIphjVC8+klBndPrWnhzsF/4pa+GUektBnlPrmkfj9o/U4ZQu6agRLf2uBfg/CXQhPIX+3CcMqput3XNmjdT0uFgPxSSqmDht6DUyoi86nrbDu+LfWuerOKVMPWZgADmo4sORrfc93ybG5y+FSK5xSOEymOwEAB2Ln+3g62Lxoar/ALctlrzhta5VKFV3n+1qp+A1yywAAAAAAAAAJO1SAmO4qd8riUXaGeXIexubyqZUM3LA2gAAOs9JAjBAMATgCcx8wBAD5wAnpOBZdydzldDX1Tk+zHTyxst6bmLhKnwbZ3lOHa70U1RR8scq0d0/CQJAOxc/28HWxeNDVf8Abn+myz5w2tcqlCr7/wDVqp+A1yyAAAAAAAAAEnapATHcVO+VxKLtDPLkPY3N5VMqGblgbQAAAAAAAAAE1Y6Dv3FuTLWSpFCnMr3r92JvSd9bE5VNN+9RZo4pnqiZabUUEdNcyaGJLGsgm+LnK1VVy+9Vxlco2iq9tEVS1xOZZGWiPhtwEgB2Ln+3g62Lxoar/tz/AE2WfOG1rlUoVff/AKtVPwGuWQAAAAAAAAAk7VIBnAqV8tU/YorVRP8AkMyrZ+7kPZ3T0mcMqWa763pJ3kPf4vpsynfG9JO8g4voyb43pJ3kHF9GTfG9JO8g4voyb43pJ3kHF9GTfG9JO8g4voyb43pJ3kHFBlLVRVsatq8yKiroImqI7mXoUlxauWze6eZU51idG3vOsRfka69ot0x1qgmqFkuVuAlcqOq5Gxt6ES4bne7CyN+p597elFHSnqxmvReLnXPhpo0jgYjG8qImNy86ryr7zwrt+u7XmqWGXHdzidV1MvgU2bL1vQmIYskjekmlC2xOIb4pqx2N8b0k0oOI4KjDb0k0oOJPp1Oxc5yftEH2k9rFzdNDXdq/hLZat1RVDbVylEqxxSs0T/GJDVLMAAAAAAAAASdqkAE/r9aVJoqqp7SQixOZNBt9av8AaU5LE5k0D1q/2kyWJzJoHrV/tJksTmTQPWr/AGkyWJzJoHrV/tJksTmTQPWr/aTJYnMmgib1zUy+kWzIR61zUy+TCatUSEfx+IQCevZIphmqOsN+yx/liJfOCnMmgjmbs/7LZFu3iOhgpzJoI9e5+0np0aGCnMmgcxc/aT0qNCxOZNBMbTc+aj0qUnPnoziPgISAAAAAAAAAJO1SAAAAAAAAAAAAAAAARV4ujZfdhBxrdT2gCQAAAAAAAAAAAAAEnapAAAAAAAAAAAAAAAAIq8XRsvuwg41up7QBIAAAAAAAAAAAAACTtUgAAAAAAAAAAAAAAAEVeLo2X3YQca3U9oAkAAAAAAAAAAAAABJ2qQAAAAAAAAAAAAAAACKvF0bL7sIONbqe0ASAAAAAAAAAAAAAAk7VIAAAAAAAAAAAAAAABFXi6Nl92EHGt1PaAJAAAAAAAAAAAAAASdqkAAAAAAAAAAAAAAAAirxdGy+7CDjW6ntAEgAAAAAAAAAAAAAJO1SAAAAAAAAAAAAAAAARV4ujZfdhBxrdT2gCQAAAAAAAAAAAAAH/2Q==";
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "logo-navigation",
  setup(__props, { expose: __expose }) {
    __expose();
    const globalStore2 = useGlobalStore();
    const __returned__ = { globalStore: globalStore2, get burdaLogo() {
      return burdaLogo;
    }, get bfLogo() {
      return bfLogo;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$2 = { class: "bf-style" };
const _hoisted_2$1 = {
  key: 0,
  fill: "none",
  height: "48",
  viewBox: "0 0 90 48",
  width: "90"
};
const _hoisted_3 = {
  key: 1,
  fill: "none",
  height: "113",
  viewBox: "0 0 292 113",
  width: "292"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    !$setup.globalStore.sidebarNavigationOpen ? (openBlock(), createElementBlock("svg", _hoisted_2$1, _cache[0] || (_cache[0] = [
      createStaticVNode('<path clip-rule="evenodd" d="M38 0H62V25.0435H38V0Z" fill="#DEDC00" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 0H18V18.7826H0V0Z" fill="#F39200" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M62 0H78V16.6957H62V0Z" fill="#007D4E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 39.6523H4V43.8263H0V39.6523Z" fill="#1DA853" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 31.3043H8V39.6522H0V31.3043ZM82 0H90V8.34783H82V0Z" fill="#008385" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 18.7826H12V31.3043H0V18.7826ZM78 0H82V4.17391H78V0Z" fill="#95C11F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M48 25.0439H62V39.6526H48V25.0439Z" fill="#65B32E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M54 39.6523H62V48.0002H54V39.6523Z" fill="#00964F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M40 25.0434H48V33.3912H40V25.0434ZM78 4.17383H82V8.34774H78V4.17383Z" fill="#F39200" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M18 0H38V20.8696H18V0ZM62 16.6957H75V30.2609H62V16.6957Z" fill="#00A19A" fill-rule="evenodd" data-v-ff80674d></path>', 10)
    ]))) : createCommentVNode("v-if", true),
    $setup.globalStore.sidebarNavigationOpen ? (openBlock(), createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
      createStaticVNode('<path clip-rule="evenodd" d="M0 0H43V44.9907H0V0ZM143 0H173V31.3889H143V0ZM216 48.1296H256V89.9815H216V48.1296Z" fill="#DEDC00" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M86 0H143V59.6389H86V0ZM203 48.1296H216V61.7315H203V48.1296Z" fill="#007D4E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 99.3984H13V113H0V99.3984Z" fill="#1DA853" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M202.715 61.6336H215.457V74.9414H202.715V61.6336ZM52 44.9912H86V80.5653H52V44.9912Z" fill="#F39200" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M161 31.3887H203V75.3331H161V31.3887Z" fill="#95C11F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M143 31.3887H161V50.222H143V31.3887Z" fill="#00964F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M239 89.9814H256V107.768H239V89.9814Z" fill="#008385" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M143 50.2227H161V69.056H143V50.2227Z" fill="#65B32E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M0 44.9907H52V99.3981H0V44.9907ZM203 0H249V48.1296H203V0Z" fill="#00A19A" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M173 0H203V31.3889H173V0Z" fill="#F39200" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M43 0H86V44.9907H43V0Z" fill="#95C11F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M249 28.25H268V48.1296H249V28.25Z" fill="#F39200" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M249 0H276V28.25H249V0Z" fill="#00964F" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M276 0H292V16.7407H276V0Z" fill="#008385" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M268 28.25H279V39.7593H268V28.25Z" fill="#65B32E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M268 39.7588H276V48.1292H268V39.7588Z" fill="#00A19A" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M276 39.7588H284V48.1292H276V39.7588Z" fill="#007D4E" fill-rule="evenodd" data-v-ff80674d></path><path clip-rule="evenodd" d="M276 16.7412H287V28.2505H276V16.7412Z" fill="#DEDC00" fill-rule="evenodd" data-v-ff80674d></path>', 18)
    ]))) : createCommentVNode("v-if", true),
    createElementVNode(
      "div",
      {
        class: normalizeClass([!$setup.globalStore.sidebarNavigationOpen ? "bf-style-logo-open" : "", "bf-style-logo"])
      },
      [
        $setup.globalStore.sidebarNavigationOpen ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: $setup.burdaLogo,
          height: "30",
          width: "201"
        }, null, 8, _hoisted_4)) : createCommentVNode("v-if", true),
        !$setup.globalStore.sidebarNavigationOpen ? (openBlock(), createElementBlock("img", {
          key: 1,
          src: $setup.bfLogo,
          height: "28",
          width: "28"
        }, null, 8, _hoisted_5)) : createCommentVNode("v-if", true)
      ],
      2
      /* CLASS */
    )
  ]);
}
const LogoNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-ff80674d"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/navigation/logo-navigation.vue"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "header-navigation",
  setup(__props, { expose: __expose }) {
    __expose();
    const userStore = useUserStore();
    const environment = GLOBAL_CONFIG.NODE_ENV;
    const slots = useSlots();
    const environmentClass = computed(() => {
      switch (environment) {
        case "local":
          return "ctf-primary";
        case "staging":
          return "ctf-orange";
        case "production":
          return "ctf-red";
        case "development":
          return "ctf-blue";
        case "sandbox":
          return "ctf-outline-blue";
        default:
          return "";
      }
    });
    const { t } = useI18n();
    const router = useRouter();
    const logout = async () => {
      try {
        await userStore.logoutCurrentUser();
      } catch (err) {
        console.log(err);
      }
    };
    const capitalizeFirstLetter = (s) => {
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    const environmentBadgeLabel = computed(() => capitalizeFirstLetter(environment));
    const goToAuthor = () => {
      if (userStore.authorUuid)
        router.push(`/authors/${userStore.authorUuid}`);
    };
    const __returned__ = { userStore, environment, slots, environmentClass, t, router, logout, capitalizeFirstLetter, environmentBadgeLabel, goToAuthor, get LanguageSelector() {
      return LanguageSelector;
    }, get QBadge() {
      return QBadge;
    }, get QBtn() {
      return QBtn;
    }, get QItem() {
      return QItem;
    }, get QItemLabel() {
      return QItemLabel;
    }, get QItemSection() {
      return QItemSection;
    }, get QList() {
      return QList;
    }, get QMenu() {
      return QMenu;
    }, get QSpace() {
      return QSpace;
    }, get QToolbar() {
      return QToolbar;
    }, get qHeaderLayoutStyles() {
      return qHeaderLayoutStyles;
    }, LogoNavigation };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = {
  key: 1,
  fill: "currentColor",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QToolbar"], null, {
    default: withCtx(() => [
      createVNode($setup["LogoNavigation"]),
      createElementVNode(
        "div",
        {
          class: "badge-container fixed",
          style: normalizeStyle($setup.qHeaderLayoutStyles)
        },
        [
          createVNode($setup["QBadge"], {
            class: "badge-env",
            outline: $setup.environment === "sandbox",
            color: $setup.environmentClass,
            label: $setup.environmentBadgeLabel
          }, null, 8, ["outline", "color", "label"])
        ],
        4
        /* STYLE */
      ),
      createVNode($setup["QSpace"]),
      createVNode($setup["LanguageSelector"], {
        "show-label": false,
        shrinked: true,
        "menu-position": "bottom",
        class: "q-pr-sm",
        dense: "",
        flat: ""
      }),
      createVNode($setup["QBtn"], {
        round: "",
        dense: "",
        flat: ""
      }, {
        default: withCtx(() => [
          $setup.slots.authorAvatar ? renderSlot(_ctx.$slots, "author-avatar", { key: 0 }) : (openBlock(), createElementBlock("svg", _hoisted_1$1, _cache[0] || (_cache[0] = [
            createElementVNode(
              "path",
              { d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.692A9.308 9.308 0 0 0 2.692 12c0 2.124.712 4.082 1.91 5.649.29-1.879 1.854-3.331 3.77-3.4l.143-.003h6.97c1.982 0 3.617 1.478 3.913 3.403A9.268 9.268 0 0 0 21.308 12 9.308 9.308 0 0 0 12 2.692zm0 2.539c2.11 0 3.802 1.677 3.802 3.727 0 2.051-1.692 3.728-3.802 3.728-2.11 0-3.802-1.677-3.802-3.728 0-2.05 1.692-3.727 3.802-3.727z" },
              null,
              -1
              /* CACHED */
            )
          ]))),
          createVNode($setup["QMenu"], null, {
            default: withCtx(() => [
              createVNode($setup["QList"], { class: "text-body1" }, {
                default: withCtx(() => [
                  createVNode($setup["QItem"], {
                    "close-popup": "",
                    clickable: "",
                    disable: $setup.userStore.authorUuid === void 0,
                    onClick: $setup.goToAuthor
                  }, {
                    default: withCtx(() => [
                      createVNode($setup["QItemSection"], null, {
                        default: withCtx(() => [
                          createVNode($setup["QItemLabel"], null, {
                            default: withCtx(() => [
                              createTextVNode(
                                toDisplayString($setup.t("navigation.authorProfile")),
                                1
                                /* TEXT */
                              )
                            ]),
                            _: 1
                            /* STABLE */
                          })
                        ]),
                        _: 1
                        /* STABLE */
                      })
                    ]),
                    _: 1
                    /* STABLE */
                  }, 8, ["disable"]),
                  createVNode($setup["QItem"], {
                    "close-popup": "",
                    clickable: "",
                    onClick: $setup.logout
                  }, {
                    default: withCtx(() => [
                      createVNode($setup["QItemSection"], null, {
                        default: withCtx(() => [
                          createVNode($setup["QItemLabel"], null, {
                            default: withCtx(() => [
                              createTextVNode(
                                toDisplayString($setup.t("navigation.logout")),
                                1
                                /* TEXT */
                              )
                            ]),
                            _: 1
                            /* STABLE */
                          })
                        ]),
                        _: 1
                        /* STABLE */
                      })
                    ]),
                    _: 1
                    /* STABLE */
                  })
                ]),
                _: 1
                /* STABLE */
              })
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 3
        /* FORWARDED */
      })
    ]),
    _: 3
    /* FORWARDED */
  });
}
const HeaderNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/navigation/header-navigation.vue"]]);
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "permission-info",
  props: {
    group: { type: String, required: true, default: "NewUser" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const props = __props;
    const groupIconMap = {
      NewUser: "eye",
      Admin: "",
      Manager: "",
      PartnerManager: "",
      ContentCreator: "",
      External: "",
      Assistant: ""
    };
    const groupLabelMap = {
      NewUser: "navigation.permissions.viewOnly",
      Admin: "",
      Manager: "",
      PartnerManager: "",
      ContentCreator: "",
      External: "",
      Assistant: ""
    };
    const icon = computed(() => groupIconMap[props.group]);
    const label = computed(() => groupLabelMap[props.group]);
    const __returned__ = { t, props, groupIconMap, groupLabelMap, icon, label, get QChip() {
      return QChip;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QChip"], {
    class: "q-pa-md",
    square: "",
    color: "blue",
    "text-color": "white",
    icon: $setup.icon,
    label: $setup.t(`${$setup.label}.label`)
  }, {
    default: withCtx(() => [
      createVNode($setup["QTooltip"], {
        class: "bg-grey-10 text-white shadow-4",
        anchor: "top middle",
        self: "bottom middle"
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString($setup.t(`${$setup.label}.hover`)),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })
    ]),
    _: 1
    /* STABLE */
  }, 8, ["icon", "label"]);
}
const PermissionInfo = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/components/permission-info.vue"]]);
const NAVIGATION_ITEMS = [
  {
    icon: "edit",
    key: "navigation.articles",
    url: "/articles",
    urlQuery: { source: ["vibe", "escenic"] },
    right: "navigate_list_articles",
    testSelector: "articles"
  },
  {
    icon: "share-2",
    key: "navigation.contentSharing",
    url: "/assembler",
    urlQuery: { articleTypes: ["contentpartner", "testpartner"] },
    right: "navigate_list_assemblers",
    testSelector: "contentSharing"
  },
  {
    icon: "image",
    key: "navigation.images",
    url: "/images",
    right: "navigate_list_images",
    testSelector: "images"
  },
  {
    icon: "gallery",
    key: "navigation.galleries",
    url: "/galleries",
    right: "navigate_list_galleries",
    testSelector: "galleries"
  },
  {
    icon: "video",
    key: "navigation.videos",
    url: "/videos",
    right: "navigate_list_videos",
    testSelector: "videos"
  },
  {
    icon: "file-text",
    key: "navigation.staticPages",
    url: "/static-page",
    right: "navigate_list_static_page",
    testSelector: "staticPages"
  },
  {
    icon: "tag",
    key: "navigation.tags",
    url: "/tags",
    right: "navigate_list_tags",
    testSelector: "tags"
  },
  {
    icon: "layers",
    key: "navigation.homeAndChannels",
    testSelector: "homeAndChannels",
    children: [
      {
        icon: "layers",
        key: "navigation.channels",
        url: "/channels",
        right: "navigate_list_channels",
        testSelector: "channels"
      },
      {
        icon: "list",
        key: "navigation.listArticles",
        url: "/article-list",
        right: "navigate_list_article_list",
        testSelector: "listArticles"
      }
    ]
  },
  {
    icon: "cat-tool",
    key: "navigation.catTool",
    url: "/cat-tool",
    right: "navigate_entrypoint_cat_tool",
    testSelector: "catTool"
  },
  {
    icon: "kim",
    key: "navigation.kim",
    url: "/kim",
    right: "navigate_entrypoint_kim",
    testSelector: "kim"
  },
  {
    icon: "send",
    key: "navigation.articlePush",
    url: "/article-push",
    right: "navigate_article_push",
    testSelector: "articlePush"
  },
  {
    icon: "zap",
    key: "navigation.widgets._title",
    testSelector: "widgets",
    children: [
      {
        icon: "link",
        key: "navigation.articlesBox",
        url: "/articles-box",
        right: "navigate_list_articles_box",
        testSelector: "articlesBox"
      },
      {
        icon: "list",
        key: "navigation.linksBox",
        url: "/links-box",
        right: "navigate_list_links_box",
        testSelector: "linksBox"
      },
      {
        icon: "cta",
        key: "navigation.ctaButton",
        url: "/cta-button",
        right: "navigate_list_cta_button",
        testSelector: "ctaButton"
      },
      {
        icon: "list",
        key: "navigation.inpageWidget",
        url: "/inpage",
        right: "navigate_list_inpage_widget",
        testSelector: "inpageWidget"
      },
      {
        icon: "type",
        key: "navigation.reusableText",
        url: "/reusable-text",
        right: "navigate_list_reusable_text",
        testSelector: "reusableText"
      },
      {
        icon: "mail",
        key: "navigation.newsletterWidgets",
        url: "/newsletter",
        right: "navigate_list_newsletter",
        testSelector: "newsletterWidgets"
      }
    ]
  },
  {
    icon: "user",
    key: "navigation.userManagement",
    testSelector: "userManagement",
    children: [
      {
        icon: "user",
        key: "navigation.users",
        url: "/users",
        right: "navigate_list_users",
        testSelector: "users"
      },
      {
        icon: "users",
        key: "navigation.authors",
        url: "/authors",
        right: "navigate_list_authors",
        testSelector: "authors"
      }
    ]
  },
  {
    icon: "tool",
    key: "navigation.tools",
    testSelector: "tools",
    children: [
      {
        icon: "database",
        key: "navigation.dataCheck",
        url: "/data-check",
        right: "data_check",
        testSelector: "dataCheck"
      },
      {
        icon: "database",
        key: "navigation.bfJobGroups",
        url: "/job-groups",
        right: "navigate_job",
        testSelector: "bfJobGroups"
      },
      {
        icon: "link-2",
        key: "navigation.seoWhiteList",
        url: "/seo-whitelist",
        right: "navigate_seo-whitelist",
        testSelector: "seoWhiteList"
      },
      {
        icon: "sync",
        key: "navigation.moduleExamples.externalTool",
        url: "/external-tool",
        right: "navigate_entrypoint_external_tool",
        testSelector: "externalTool"
      },
      {
        icon: "signpost",
        key: "navigation.channelizer",
        url: "/channelizer",
        right: "navigate_channelizer",
        testSelector: "channelizer"
      },
      {
        icon: "redo",
        key: "navigation.redirect",
        url: "/redirect",
        right: "navigate_redirect_management",
        testSelector: "redirect"
      },
      {
        icon: "server",
        key: "navigation.apiTeaser",
        url: "/api-teaser",
        right: "navigate_list_api_teaser",
        testSelector: "apiTeaser"
      },
      {
        icon: "database",
        key: "navigation.authorMerge",
        url: "/author-merge",
        right: "navigate_author_merge",
        testSelector: "authorMerge"
      }
    ]
  },
  {
    icon: "group",
    key: "navigation.partnerManagement._title",
    testSelector: "partnerManagement",
    right: "manage_partners",
    children: [
      {
        icon: "rss",
        key: "navigation.assemblerFeeds",
        url: "/assembler-feeds",
        urlQuery: {
          autopublish: null,
          importType: null,
          periodicPull: null,
          isContentVisibleInCtf: null
        },
        right: "manage_partners",
        testSelector: "assemblerFeeds"
      },
      {
        icon: "users",
        key: "navigation.partners",
        url: "/partners",
        right: "manage_partners",
        testSelector: "partners"
      }
    ]
  }
];
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "sidebar-nav-item",
  props: {
    item: { type: Object, required: true },
    isSidebarOpen: { type: Boolean, required: true },
    hasIcon: { type: Boolean, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const router = useRouter();
    const { t } = useI18n();
    const isSubmenuOpen = ref(false);
    const hasChildren = computed(() => {
      var _a;
      return !!((_a = props.item.children) == null ? void 0 : _a.length);
    });
    const isSidebarOpen = computed(() => props.isSidebarOpen);
    const routeTo = computed(() => {
      if (!props.item.url || props.item.isExternalUrl)
        return void 0;
      return { path: props.item.url, query: props.item.urlQuery };
    });
    const externalHref = computed(() => props.item.isExternalUrl ? props.item.url : void 0);
    const isActiveRoute = computed(() => {
      if (!props.item.url || props.item.isExternalUrl)
        return false;
      const current = router.currentRoute.value;
      return current.path === props.item.url || !!current.matched.find((route) => route.path === props.item.url);
    });
    const cutChildren = (item) => {
      const { children, ...noChildren } = item;
      return noChildren;
    };
    const onSubmenuToggle = debounce((isOpen) => {
      if (props.isSidebarOpen)
        return;
      isSubmenuOpen.value = isOpen;
    }, 200);
    const __returned__ = { props, router, t, isSubmenuOpen, hasChildren, isSidebarOpen, routeTo, externalHref, isActiveRoute, cutChildren, onSubmenuToggle, get QExpansionItem() {
      return QExpansionItem;
    }, get QIcon() {
      return QIcon;
    }, get QItem() {
      return QItem;
    }, get QItemLabel() {
      return QItemLabel;
    }, get QItemSection() {
      return QItemSection;
    }, get QList() {
      return QList;
    }, get QMenu() {
      return QMenu;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sidebar_nav_item = resolveComponent("sidebar-nav-item", true);
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      createCommentVNode(" LEAF ITEM (no children) "),
      !$setup.hasChildren ? (openBlock(), createBlock($setup["QItem"], {
        key: 0,
        to: $setup.routeTo,
        href: $setup.externalHref,
        target: $props.item.isExternalUrl ? "_blank" : void 0,
        class: "sidebar__link text-white",
        "active-class": "sidebar__link--active",
        active: $setup.isActiveRoute,
        link: "",
        "data-qa-sidemenu": $props.item.testSelector
      }, {
        default: withCtx(() => [
          $props.hasIcon ? (openBlock(), createBlock($setup["QItemSection"], {
            key: 0,
            avatar: ""
          }, {
            default: withCtx(() => [
              createVNode($setup["QIcon"], {
                color: "white",
                name: $props.item.icon
              }, null, 8, ["name"])
            ]),
            _: 1
            /* STABLE */
          })) : createCommentVNode("v-if", true),
          createVNode($setup["QItemSection"], null, {
            default: withCtx(() => [
              createVNode($setup["QItemLabel"], null, {
                default: withCtx(() => [
                  createTextVNode(
                    toDisplayString($setup.t($props.item.key)),
                    1
                    /* TEXT */
                  )
                ]),
                _: 1
                /* STABLE */
              })
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 1
        /* STABLE */
      }, 8, ["to", "href", "target", "active", "data-qa-sidemenu"])) : (openBlock(), createElementBlock(
        Fragment,
        { key: 1 },
        [
          createCommentVNode(" ITEM WITH CHILDREN "),
          $setup.isSidebarOpen ? (openBlock(), createBlock($setup["QExpansionItem"], {
            key: 0,
            color: "white",
            label: $setup.t($props.item.key),
            icon: $props.item.icon,
            "expand-icon": "keyboard_arrow_down",
            "expand-icon-class": "text-white",
            class: "sidebar__item-expandable sidebar__item-divided",
            "header-class": "sidebar__link",
            dense: "",
            "default-opened": false,
            "data-qa-sidemenu": $props.item.testSelector
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($props.item.children, (child) => {
                  return openBlock(), createBlock(_component_sidebar_nav_item, {
                    key: child.key,
                    item: child,
                    "is-sidebar-open": $setup.isSidebarOpen,
                    "has-icon": true
                  }, null, 8, ["item", "is-sidebar-open"]);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _: 1
            /* STABLE */
          }, 8, ["label", "icon", "data-qa-sidemenu"])) : (openBlock(), createBlock($setup["QItem"], {
            key: 1,
            class: "sidebar__link sidebar__item sidebar__item-expandable--shortened sidebar__item-divided",
            link: "",
            onMouseover: _cache[3] || (_cache[3] = ($event) => $setup.onSubmenuToggle(true)),
            onMouseout: _cache[4] || (_cache[4] = ($event) => $setup.onSubmenuToggle(false))
          }, {
            default: withCtx(() => [
              createVNode($setup["QItemSection"], { avatar: "" }, {
                default: withCtx(() => [
                  createVNode($setup["QIcon"], {
                    color: "white",
                    name: $props.item.icon
                  }, null, 8, ["name"])
                ]),
                _: 1
                /* STABLE */
              }),
              createVNode($setup["QItemSection"], null, {
                default: withCtx(() => [
                  createVNode($setup["QItemLabel"], null, {
                    default: withCtx(() => [
                      createTextVNode(
                        toDisplayString($setup.t($props.item.key)),
                        1
                        /* TEXT */
                      )
                    ]),
                    _: 1
                    /* STABLE */
                  })
                ]),
                _: 1
                /* STABLE */
              }),
              createVNode($setup["QMenu"], {
                modelValue: $setup.isSubmenuOpen,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.isSubmenuOpen = $event),
                anchor: "top left",
                self: "top right",
                offset: [4, 0],
                "transition-show": "fade",
                "transition-hide": "fade",
                class: "sidebar__item-expandable text-weight-bold",
                square: "",
                onMouseover: _cache[1] || (_cache[1] = ($event) => $setup.onSubmenuToggle(true)),
                onMouseout: _cache[2] || (_cache[2] = ($event) => $setup.onSubmenuToggle(false))
              }, {
                default: withCtx(() => [
                  createVNode($setup["QList"], { dense: "" }, {
                    default: withCtx(() => [
                      createCommentVNode(" Submenu label "),
                      (openBlock(), createBlock(_component_sidebar_nav_item, {
                        key: $props.item.key,
                        item: $setup.cutChildren($props.item),
                        "is-sidebar-open": false,
                        "has-icon": false,
                        class: "sidebar__link--hover"
                      }, null, 8, ["item"])),
                      createCommentVNode(" Submenu items "),
                      (openBlock(true), createElementBlock(
                        Fragment,
                        null,
                        renderList($props.item.children, (child) => {
                          return openBlock(), createBlock(_component_sidebar_nav_item, {
                            key: child.key,
                            item: child,
                            "is-sidebar-open": false,
                            "has-icon": false
                          }, null, 8, ["item"]);
                        }),
                        128
                        /* KEYED_FRAGMENT */
                      ))
                    ]),
                    _: 1
                    /* STABLE */
                  })
                ]),
                _: 1
                /* STABLE */
              }, 8, ["modelValue"])
            ]),
            _: 1
            /* STABLE */
          }))
        ],
        64
        /* STABLE_FRAGMENT */
      ))
    ],
    2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}
const SidebarNavItem = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/navigation/sidebar-nav-item.vue"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "sidebar-navigation",
  setup(__props, { expose: __expose }) {
    __expose();
    const globalStore2 = useGlobalStore();
    const userStore = useUserStore();
    const router = useRouter();
    const { t } = useI18n();
    const menuItems = ref(NAVIGATION_ITEMS);
    const buildNumber = ref("");
    onMounted(() => {
      buildNumber.value = GLOBAL_CONFIG.VERSION;
    });
    const filteredItems = computed(() => {
      const filterItems = (items) => items.filter((item) => !item.right || userStore.hasRight(item.right));
      const rootItems = filterItems(menuItems.value);
      rootItems.forEach((item) => {
        if (item.children)
          item.children = filterItems(item.children);
      });
      return rootItems;
    });
    const sidebarStyle = computed(() => {
      return `padding-top: ${globalStore2.sidebarNavigationOpen ? 55 : 20}px`;
    });
    const sidebarChevron = computed(() => {
      return `chevron_${globalStore2.sidebarNavigationOpen ? "left" : "right"}`;
    });
    const goToAuthor = () => {
      if (userStore.authorUuid)
        router.push(`/authors/${userStore.authorUuid}`);
    };
    const __returned__ = { globalStore: globalStore2, userStore, router, t, menuItems, buildNumber, filteredItems, sidebarStyle, sidebarChevron, goToAuthor, get QBtn() {
      return QBtn;
    }, get QList() {
      return QList;
    }, get QSpace() {
      return QSpace;
    }, PermissionInfo, SidebarNavItem };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = { class: "sidebar__bottom white--text d-flex flex-center sidebar__item-divided" };
const _hoisted_2 = ["textContent"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      style: normalizeStyle($setup.sidebarStyle),
      class: "sidebar"
    },
    [
      $setup.globalStore.sidebarNavigationOpen ? (openBlock(), createBlock($setup["QBtn"], {
        key: 0,
        class: "text-white text-body1",
        label: `${$setup.t("navigation.hello")}, ${$setup.userStore.firstName}!`,
        flat: "",
        "no-caps": "",
        onClick: $setup.goToAuthor
      }, null, 8, ["label"])) : createCommentVNode("v-if", true),
      $setup.userStore.group === "NewUser" && $setup.globalStore.sidebarNavigationOpen ? (openBlock(), createBlock($setup["PermissionInfo"], {
        key: 1,
        class: "sidebar__permission-info q-mb-lg",
        group: $setup.userStore.group
      }, null, 8, ["group"])) : createCommentVNode("v-if", true),
      createVNode($setup["QList"], { dense: "" }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($setup.filteredItems, (item) => {
              return openBlock(), createBlock($setup["SidebarNavItem"], {
                key: item.key,
                item,
                "is-sidebar-open": $setup.globalStore.sidebarNavigationOpen,
                "has-icon": true
              }, null, 8, ["item", "is-sidebar-open"]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ]),
        _: 1
        /* STABLE */
      }),
      createVNode($setup["QSpace"]),
      createElementVNode("div", _hoisted_1, [
        $setup.globalStore.sidebarNavigationOpen ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: "col q-pl-md",
          textContent: toDisplayString(`Version: ${$setup.buildNumber}`)
        }, null, 8, _hoisted_2)) : createCommentVNode("v-if", true),
        createVNode($setup["QBtn"], {
          flat: "",
          icon: $setup.sidebarChevron,
          title: $setup.t("navigation.minimize"),
          onClick: _cache[0] || (_cache[0] = ($event) => $setup.globalStore.toggleSidebarNavigation())
        }, null, 8, ["icon", "title"])
      ])
    ],
    4
    /* STYLE */
  );
}
const SidebarNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/navigation/sidebar-navigation.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "main-layout",
  setup(__props, { expose: __expose }) {
    __expose();
    const drawer = ref();
    const globalStore2 = useGlobalStore();
    const __returned__ = { drawer, globalStore: globalStore2, get DEFAULT_SIDEBAR_NAV_WIDTH() {
      return DEFAULT_SIDEBAR_NAV_WIDTH;
    }, get QDrawer() {
      return QDrawer;
    }, get QHeader() {
      return QHeader;
    }, get QLayout() {
      return QLayout;
    }, get RouterView() {
      return RouterView;
    }, HeaderNavigation, SidebarNavigation };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QLayout"], { view: "hHh Lpr LFF" }, {
    default: withCtx(() => [
      createVNode($setup["QHeader"], {
        id: "mainNavigationHeader",
        bordered: "",
        class: "topbar"
      }, {
        default: withCtx(() => [
          createVNode($setup["HeaderNavigation"], null, {
            "author-avatar": withCtx(() => [
              renderSlot(_ctx.$slots, "author-avatar", {}, void 0, true)
            ]),
            _: 3
            /* FORWARDED */
          })
        ]),
        _: 3
        /* FORWARDED */
      }),
      createVNode($setup["QDrawer"], {
        id: "mainNavigationSidebar",
        ref: "drawer",
        "model-value": true,
        mini: !$setup.globalStore.sidebarNavigationOpen,
        bordered: "",
        side: "left",
        width: $setup.DEFAULT_SIDEBAR_NAV_WIDTH,
        class: "bfPetrol",
        behavior: "desktop"
      }, {
        default: withCtx(() => [
          createVNode($setup["SidebarNavigation"])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["mini", "width"]),
      createVNode($setup["RouterView"])
    ]),
    _: 3
    /* FORWARDED */
  });
}
const mainLayout = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5a2a5a0e"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-layout-utils/src/main-layout.vue"]]);
export {
  BLOCK_DRAWER_CONFIG,
  BLOCK_DRAWER_MINI_WIDTH,
  BLOCK_DRAWER_WIDTH,
  editView_layout as EditViewLayout,
  HEADER_HEIGHT_HINT,
  HeaderNavigation,
  ListPagination,
  listView_layout as ListViewLayout,
  LogoNavigation,
  mainLayout as MainLayout,
  SidebarNavigation,
  statusIcon as StatusIcon
};
//# sourceMappingURL=index.es.js.map
